import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './Locksmith.module.scss';

export const Locksmith = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/locksmith/Locksmith.webp"
        imageAlt="Locksmith working on glass door lock"
        title="Locksmith"
      />

      <section className={styles.services}>
        <div className={styles.services_card_block}>
          <div className={styles.container}>
            <div className={styles.inner_section}>
              <TitleAndDescComponent
                styles={styles}
                title="Locksmiths in London"
                description="We aim to secure your property one lock at a time. Fast and dependable locksmith services for your home, property and peace of mind."
              />

              <CTAButton title="Book a Locksmith" serviceName="Locksmith" />
              <div
                className={cx(
                  styles.wrap_section,
                  styles.service_content_container,
                )}>
                <TitleAndDescComponent
                  styles={styles}
                  subTitle="Locksmith Services"
                />
                <div className={styles.service_items}>
                  <ServiceItem
                    styles={styles}
                    imgSrc="/images/services/locksmith/locked out.webp"
                    imgAlt="woman locked out of her house calling a locksmith"
                    title="Emergency Lock-Out"
                    description="Getting locked out of your home or business can be a stressful and urgent situation, especially at inconvenient times. Our emergency lock-out service is available to get you back inside safely and quickly. With prompt response times and skilled locksmiths, we ensure you're never left out in the cold, providing you peace of mind whenever an emergency strikes."
                  />

                  <ServiceItem
                    styles={styles}
                    imgSrc="/images/services/locksmith/Lock Installation and Repairs.webp"
                    imgAlt="locksmith installing new door lock"
                    title="Lock Installation and Repairs"
                    description="Proper lock installation and timely repairs are essential for maintaining the security of your property. Whether you need a new lock installed or an existing one repaired, our professional locksmiths are equipped to handle any situation. We use high-quality locks and expert techniques to provide you with dependable security, keeping your home or business safe from potential threats."
                  />

                  <ServiceItem
                    styles={styles}
                    imgSrc="/images/services/locksmith/Key Cutting.webp"
                    imgAlt="key cutting device for locksmiths"
                    title="Key cutting"
                    description="Key cutting is a crucial service for anyone who needs spare keys for their home, property, or business. Our professional key cutting service ensures precise duplicates that work seamlessly, whether you need an extra set for family members, tenants, or as a backup. We use advanced equipment to provide fast, accurate key copies, giving you the convenience and peace of mind of always having a spare when you need it."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <EmergencyComponent
        title="Local Locksmiths in London"
        imageSrc="/images/services/locksmith/silver keys.webp"
        imageAlt="row of assorted keys"
        styles={styles}
        para1="Broken locks, lost keys, or jammed doors can easily turn a good day into a bad one. Our expert locksmiths are ready to handle everything from emergency lockouts to key replacements, and do it all quickly and efficiently."
        para2="Whether it's a lock that needs fixing or keys that decided to go on vacation without you, our experienced locksmiths in London are here to restore your peace of mind."
      />
      <ListOfServices
        styles={styles}
        serrviceList={[
          { name: 'Broken Key Extractions' },
          { name: 'Safe Opening Service' },
          { name: 'uPVC Door and Window Lock Repairs' },
          { name: 'Garage Door Lock Repairs' },
          { name: 'Emergency Lock-Out' },
          { name: 'Lock Installation and Repairs' },
          { name: 'Key cutting' },
        ]}
      />
      <AreasWeCover styles={styles} />
      <PostCodes styles={styles} mainPageUrl="/services/locksmith" />
      <FAQsView title="Locksmith FAQs" faqItems={faqItems} />
    </>
  );
};
// {name: ""},

const faqItems = [
  {
    title: 'Can a locksmith open my door without damaging my lock?',
    details: `Yes, our skilled locksmiths use non-destructive methods to gain entry whenever possible. In most cases, they can unlock doors without damaging the lock or door.`,
  },
  {
    title: 'Can locksmiths cut new keys on-site?',
    details:
      'Yes, our locksmiths have mobile equipment to cut new keys on-site, whether for doors, windows, or other types of locks. This is especially helpful for lost or damaged keys.',
  },
  {
    title: 'What is lock rekeying, and when is it useful?',
    details: `Rekeying changes a lock's internal pins, so it works with a new key, making old keys ineffective. It’s a cost-effective way to secure your property, especially after moving into a new home or losing keys.`,
  },
  {
    title: 'What should I do if I lose my house keys?',
    details: `Contact our locksmith to rekey or change your locks to prevent unauthorised access. They can also provide replacement keys or suggest security upgrades if needed.`,
  },
];
